module.exports = __webpack_public_path__ + "img/jazz-22-en.b41e53b2.jpg";